import { Pipe, PipeTransform } from '@angular/core';
import { parseTimeframeName } from '@app/core/translations';
import { TimeframeOptionParts } from './timeframe-option-parts.model';

@Pipe({
  name: 'timeframeOptionParts',
})
export class TimeframeOptionPartsPipe implements PipeTransform {
  transform(name: string): TimeframeOptionParts {
    return parseTimeframeName(name);
  }
}
